<template>
  <div class="dialog">
    <div class="dialogInner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(#000, .5);
  z-index: 5000;
  .dialogInner {
    width: 345px;
    min-height: 200px;
    background-color: #fff;
    padding: 20px 15px;
    border-radius: 8px;
    position: relative;
    .closeBtn {
      position: absolute;
      width: 40px;
      height: 20px;
      top: 10px;
      right: 5px;
      outline: none;
      background-image:
        linear-gradient(
          20deg,
          transparent 0%,
          transparent 44%,
          #585757 50%,
          transparent 55%),
      linear-gradient(
        160deg,
        transparent 0%,
        transparent 44%,
        #585757 50%,
        transparent 55%);
      background-repeat: no-repeat;
      background-size: 28px 10px;
      background-position: 5px 5px, 5px 5px;
    }
  }
}
</style>
